<script>
    import {HeroForm} from '../store.js';
    import {getContext} from 'svelte';
    let dataState1 = false;
    let dataState2 = false;
    let CheckBox = true;
    const {url} = getContext('APP');
    const formNo = Object.fromEntries(new URLSearchParams($url.search));
    const formData = {
        business: '',
        draperStartup: '',
    };
    if (HeroForm.get() != undefined) {
        formData.business = HeroForm.get().business;
        formData.draperStartup = HeroForm.get().startup;
        if (formData.draperStartup == 'Yes') {
            dataState1 = true;
        } else if (formData.draperStartup == 'No') {
            dataState2 = true;
        }
    }
    $: if (HeroForm.get() != undefined) {
        HeroForm.update((n)=> n={session: HeroForm.get().session, name: HeroForm.get().name, email: HeroForm.get().email,
            country: HeroForm.get().country, countryCode: HeroForm.get().countryCode,
            city: HeroForm.get().city, phoneNumber: HeroForm.get().phoneNumber, dateOfBirth: HeroForm.get().dateOfBirth,
            gender: HeroForm.get().gender,
            technicalSkill: HeroForm.get().technicalSkill, englishAbility: HeroForm.get().englishAbility,
            industry: HeroForm.get().industry, industryOther: HeroForm.get().industryOther,
            business: formData.business, visa: HeroForm.get().visa,
            aid: HeroForm.get().aid, referalName: HeroForm.get().referalName,
            hearAbout: HeroForm.get().hearAbout, hearAboutOthers: HeroForm.get().hearAboutOthers,
            startup: formData.draperStartup,
            aboutYourSelf: HeroForm.get().aboutYourSelf,
            portfolioURL: HeroForm.get().portfolioURL, buildingPlan: HeroForm.get().buildingPlan,
            travelBudget: HeroForm.get().travelBudget, buildingWeeks: HeroForm.get().buildingWeeks,
            invitedtoProgram: HeroForm.get().invitedtoProgram, ackowledged: HeroForm.get().ackowledged,
        });
    }
    /**
     *
     * @param {string}object
     */
    async function SaveData() {
        if (formNo.name === 'FundamentalsOfEntrepreneurship') {
            location.href='/apply?name=FundamentalsOfEntrepreneurship&FormNo=submitform';
        } else if (formNo.name === 'CorporateInnovation') {
            location.href='/apply?name=CorporateInnovation&FormNo=submitform';
        } else if (formNo.name === 'Blockchain') {
            location.href='/apply?name=Blockchain&FormNo=submitform';
        } else if (formNo.name === 'CorporateAccelerator') {
            location.href='/apply?name=CorporateAccelerator&FormNo=submitform';
        }
    }
    $: if ((dataState1 == false) && (dataState2 == false)) {
        CheckBox = true;
    } else {
        CheckBox = false;
    }
    /**
     *
     *
     */
    function goBack() {
        if (formNo.name === 'FundamentalsOfEntrepreneurship') {
            location.href='/apply?name=FundamentalsOfEntrepreneurship&FormNo=secondform';
        } else if (formNo.name === 'CorporateInnovation') {
            location.href='/apply?name=CorporateInnovation&FormNo=secondform';
        } else if (formNo.name === 'Blockchain') {
            location.href='/apply?name=Blockchain&FormNo=secondform';
        } else if (formNo.name === 'CorporateAccelerator') {
            location.href='/apply?name=CorporateAccelerator&FormNo=secondform';
        }
    }
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <div class="desktop">
        <div class="back-div">
            <div>
                <div class="process">
                    <p>Process</p>
                </div>
                <div class="process_x">
                    <p>
                        Our Application is a 4 step process, where you provied
                        the requierd information. This form costs $5 for
                        submission.
                    </p>
                </div>
            </div>
            <ul style="list-style: none;">
                {#each Array(3) as _, i}
                    <li class="vl" />
                {/each}
            </ul>
            <div class="front-div">
                <div>
                    <div class="back-arrow" on:click={() => ( goBack())}>
                        <img src="images/apply/back_arrow.svg" alt="">
                    </div>
                    <form on:submit|preventDefault={SaveData}>
                        <div>
                            <div style="margin-left: 4.96vw;" class="text">
                                <label for="idea"
                                    >Pitch us your business Or tell us why you
                                    were put on this Earth</label
                                >
                                <p
                                    style="margin-top: 0.529vw;font-size:0.794vw; color:#B8B8B8;"
                                >
                                    * We'll decide to move your application to
                                    the next phase with the information that you
                                    are providing here. You may write a response
                                    in <br /> the space available or paste the URL
                                    to a 60 second video response (Youtube, Vimeo,
                                    etc.).
                                </p>

                                <div style="margin-top: 0.529vw;">
                                    <input
                                        required
                                        type="text"
                                        id="f_name"
                                        placeholder="max 250 words"
                                        style="width: 51.257vw;"
                                        bind:value={formData.business}
                                    />
                                </div>
                            </div>
                            <div style="margin-left: 4.96vw;">
                                <label for="f_name"
                                    >Would you like to stay one of the Draper
                                    Startup Houses during the program? (+$150)</label
                                >
                                <p
                                    style="margin-top: 0.529vw;font-size:0.794vw; color:#B8B8B8;"
                                >
                                    Locations: Austin-Texas, Bali-Indonesia,
                                    Bangalore Flagship-Koramangala, Chiangg
                                    Mai-Thailand, Lisbon-Portugal, Manila- <br
                                    />Philippines, Singapore-Singapore,
                                    Tallinn-Estonia, Yangon-Myanmar
                                </p>
                            </div>
                            <div
                                style="margin-left: 4.96vw;margin-top: 0.529vw; display:flex;"
                            >
                                <div>
                                    <p
                                        style="font-size:0.926vw;font-weight:600;"
                                    >
                                        Yes
                                    </p>
                                </div>
                                <div style="margin-left: 0.926vw;">
                                    <input
                                        bind:checked={dataState1}
                                        bind:value={formData.draperStartup}
                                        bind:this={CheckBox}
                                        on:click={() => {
                                            if (dataState1 === false) {
                                                dataState1 = true;
                                                dataState2 = false;
                                                formData.draperStartup = 'Yes';
                                            }
                                        }}
                                        class="checkbox"
                                        type="checkbox"
                                        required={CheckBox}
                                    />
                                </div>
                            </div>
                            <div
                                style="margin-left: 4.96vw;margin-top: 0.529vw; display:flex;"
                            >
                                <div>
                                    <p
                                        style="font-size:0.926vw;font-weight:600;"
                                    >
                                        No
                                    </p>
                                </div>
                                <div style="margin-left: 1.3vw;">
                                    <input                                       
                                        bind:checked={dataState2}
                                        on:click={() => {
                                            if (dataState2 === false) {
                                                dataState2 = true;
                                                dataState1 = false;
                                                formData.draperStartup = 'No';
                                            }
                                        }}
                                        class="checkbox"
                                        type="checkbox"
                                        required={CheckBox}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style="margin-left: 5vw; margin-top: 2.116vw;">
                            <button
                                style=" background-color: rgba(60, 116, 192, 1);
                                        border-radius: 1.984vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 1.190vw;"
                              >Next</button
                            >
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile">
        <div class="back-div-mobile">
            <div style="position: absolute;">
                <p class="process-mobile">Process</p>

                <p class="process_x-mobile">
                    Our Application is a 4 step process, where you provied the
                    requierd information. This form costs $5 for submission.
                </p>
            </div>

            <div style="padding-top: 33vw;">
                <ul
                    style="list-style: none; display: flex; gap: 24.5vw;width: 75vw;padding-left: 15vw;">
                    {#each Array(3) as _, i}
                        <li class="vl-mobile" />
                    {/each}
                </ul>
            </div>

            <div class="front-div-mobile">
                <form on:submit|preventDefault={SaveData}>
                    <div>
                        <div style="margin-left: 4.96vw;" class="text">
                            <p class="p-mobile">
                                Pitch us your business Or tell us why you <br>
                                were put on this Earth
                            </p>
                            <p
                                style="margin-top: 0.529vw;font-size:2.778vw; color:#B8B8B8;width:78.333vw;"
                            >
                                * We'll decide to move your application to
                                the next phase with the information that you
                                are providing here. You may write a response
                                in the space available or paste the URL
                                to a 60 second video response (Youtube, Vimeo,
                                etc.).
                            </p>

                            <div style="margin-top: 0.529vw;">
                                <textarea
                                    required
                                    type="text"
                                    class="textarea-mobile"
                                    rows="5"
                                    placeholder="Max count 250 words"
                                    bind:value={formData.business}
                                />
                            </div>
                        </div>
                        <div style="margin-left: 4.96vw;">
                            <p class="p-mobile">
                                Would you like to stay one of the Draper
                                Startup <br> Houses during the program? (+$150)
                            </p>
                           
                        
                            <p
                                style="margin-top: 0.529vw;font-size:2.778vw; color:#B8B8B8;width:78.333vw;"
                            >
                                Locations: Austin-Texas, Bali-Indonesia,
                                Bangalore Flagship-Koramangala, Chiangg
                                Mai-Thailand, Lisbon-Portugal, Manila-Philippines, Singapore-Singapore,
                                Tallinn-Estonia, Yangon-Myanmar
                            </p>
                        </div>
                        <div
                            style="margin-left: 4.96vw;margin-top: 0.529vw; display:flex;"
                        >
                            <div>
                                <p
                                    style="font-size: 3.889vw;
                                            font-weight: 600;
                                            margin-top: 0.8vw;"
                                >
                                    Yes
                                </p>
                            </div>
                            <div style="    margin-left: 3.926vw;margin-top: 1vw;">
                                <input
                                    bind:checked={dataState1}
                                    bind:value={formData.draperStartup}
                                    bind:this={CheckBox}
                                    on:click={() => {
                                        if (dataState1 === false) {
                                            dataState1 = true;
                                            dataState2 = false;
                                            formData.draperStartup = 'Yes';
                                        }
                                    }}
                                    class="checkbox-mobile"
                                    type="checkbox"
                                    required={CheckBox}
                                />
                            </div>
                        </div>
                        <div
                            style="margin-left: 4.96vw;margin-top: 0.529vw; display:flex;"
                        >
                            <div>
                                <p
                                    style="font-size: 3.889vw;
                                        font-weight: 600;
                                        margin-top: 0.8vw;"
                                >
                                    No
                                </p>
                            </div>
                            <div style="    margin-left: 5.3vw;margin-top: 1vw;">
                                <input
                                    bind:checked={dataState2}
                                    on:click={() => {
                                        if (dataState2 === false) {
                                            dataState2 = true;
                                            dataState1 = false;
                                            formData.draperStartup = 'No';
                                        }
                                    }}
                                    class="checkbox-mobile"
                                    type="checkbox"
                                    required={CheckBox}
                                />
                            </div>
                        </div>
                    </div>
                    <div style="margin-left: 8vw; margin-top: 5vw; display: flex; gap: 4.673vw;">
                        <button
                            style=" background-color: rgba(60, 116, 192, 1);
                                border-radius: 6.069vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 3.889vw;"
                          >Next</button>
                          <div class="back-arrow-mob" on:click={() => ( goBack())}>
                            <img src="images/apply/back_button.svg" alt="">
                          </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>

<style>
    .back-arrow{
        width: 1.72vw;
        height: 0.926vw;
        margin-left: 2.646vw;
        margin-bottom: -1vw;
        margin-top: 1.323vw;
        cursor: pointer;
    }
    .back-arrow img{
        width: 100%;
        height: 100%;
    }
    .back-div {
        position: relative;
    height: 36.812vw;
    background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
    border-top-left-radius: 2vw;
    display: flex;
    margin-bottom: -0.1vw;
    margin-top: 1.1vw;
    }
    .front-div {
        position: absolute;
    width: 100%;
    height: 35.384vw;
    background: #ffffff;
    border-bottom-left-radius: 2vw;
    border-bottom-right-radius: 2vw;
    left: 22.25vw;
    bottom: 1.6vw;
    }

    .process {
        font-size: 1.984vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 3vw;
        margin-top: 4.497vw;
    }
    .process_x {
        width: 15.013vw;
        font-size: 0.926vw;
        color: rgb(255 255 255);
        font-weight: 300;
        margin-left: 3vw;
    }
    .vl {
        margin-top: 1.984vw;
        border-radius: 0.5vw;
        width: 0.463vw;
        border-left: 0.5vw solid rgba(60, 116, 192, 1);
        height: 5.82vw;
        opacity: 0.3;
        margin-left: 0vw;
    }
    .vl:nth-child(3) {
        border-left: 0.5vw solid white;
        opacity: 100;
    }
    input {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        font-size: 0.926vw;
    }
    input::placeholder {
        font-size: 0.926vw;
    }
    label {
        font-size: 1.058vw;
        margin-top: 1.984vw;
        color: rgba(0, 0, 0, 1);
        font-weight: 700;
    }
    .checkbox {
        width: 1.389vw;
        height: 1.323vw;
        border-radius: 0.198vw;
        border: 0.132vw solid rgba(60, 136, 195, 1);
        opacity: 40;
        background-color: #3c88c3;
    }
    .back-div-mobile {
        position: relative;
        height: 183vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 8vw;
        border-top-right-radius: 8vw;
        margin-bottom: -0.2vw;
    }
    .process-mobile {
        font-size: 5.556vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 7.222vw;
        padding-top: 9.167vw;
    }
    .process_x-mobile {
        width: 73.889vw;
        font-size: 3.056vw;
        color: rgb(255 255 255);
        margin-left: 7.222vw;
    }
    .vl-mobile {
        border-radius: 0.5vw;
        border-left: 1.3vw solid rgba(60, 116, 192, 1);
        height: 15.460999999999999vw;
        opacity: 0.3;
        margin-left: 0vw;
        transform: rotate(90deg);
    }
    .vl-mobile:nth-child(3) {
        border-left: 1.3vw solid white;
        opacity: 100;
    }
    .front-div-mobile {
        position: absolute;
        width: 92.778vw;
        background: #ffffff;
        border-top-left-radius: 4.5vw;
        border-bottom-left-radius: 4.5vw;
        left: 7.222vw;
        padding-bottom: 5vw;
        top: 45vw;
    }
    .p-mobile {
        font-size: 3.022vw;
        margin-top: 6.667vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 700;
    }
    .textarea-mobile {
        width: 78.333vw;
        height: 27.778vw;
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 2.778vw;
        padding-left: 5.5vw;
        padding-top: 0.595vw;
    }
    .checkbox-mobile {
        width: 3.731vw;
        height: 3.731vw;
        border-radius: 6.198vw;
        border: 5vw solid rgba(60, 136, 195, 1);
        opacity: 40;
    }
    .desktop {
        display: block;
        width: 100%;
        overflow: hidden;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .back-arrow-mob{
            width: 10.047vw;
            height: 7.243vw;
        }
        .back-arrow-mob img{
            width: 100%;
            height: 100%;
        }
    }
</style>
